"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AttachmentsAPI = require("crm_ui/attachments/data/AttachmentsAPI");

var _definePooledObjectStore = require("crm_data/flux/definePooledObjectStore");

var _registerPooledObjectService = _interopRequireDefault(require("crm_data/flux/registerPooledObjectService"));

var PREFIX = 'ATTACHMENTS';
(0, _registerPooledObjectService.default)({
  actionTypePrefix: PREFIX,
  fetcher: _AttachmentsAPI.fetch
});

var _default = (0, _definePooledObjectStore.definePooledObjectStore)({
  actionTypePrefix: PREFIX
}).register();

exports.default = _default;
module.exports = exports.default;